import React from "react"
import GlobalStyles from "@mui/material/GlobalStyles"
import {breakpoints} from "@next/themes"
import {PLP_ID} from "./config/constants"

export const globalStyle = (
    <GlobalStyles
        styles={`
            body {
                overflow-y: scroll;
                margin: 0;
                font-synthesis: none;
                height: 100vh;
                display: flex;
                flex-direction: column;
            }

            img:-moz-loading{ visibility:hidden; }

            *{ box-sizing:border-box; }

            .platform_modernisation_plp {
                & button:focus, a:focus {
                    outline: none;
                }

                & *[data-focus-visible-added]:not(input):focus { outline: 2px solid #1d89dd; }

                & input[data-focus-visible-added]:focus  + label { outline: 2px solid #1d89dd; }
                & input[data-focus-visible-added][type="button"]:focus { outline: 2px solid #1d89dd; }
                #plp-tabbed-brand-search-bar-input:focus {
                    outline: none;
                }
            }

            #next-header-entrypoint {
                position: fixed;
                z-index: 1100;
            }

            #next-footer-entrypoint {
                position: relative;
                @media (min-width: ${breakpoints.values.lg}px) {
                    z-index: 2;
                }
            }

            #${PLP_ID}, #${PLP_ID}:focus {
                outline: 0;
                --next-plp-products-header-height: 51px;
            }

            #${PLP_ID}, #${PLP_ID}:focus {
                outline: 0;
                --next-plp-breadcrumbs-height: 36px;
            }

            #${PLP_ID}[data-container-page] {
                position: relative;
                margin-top:0;
                padding-top: var(--next-header-height, 5.5rem);
                flex-grow: 1;
                /* -1px to prevent PS tiles clipping under the header on page zoom in/out */
                @media (min-width: ${breakpoints.values.md}px) {
                    padding-top: calc(var(--next-header-md-height, 6.5625rem) - 1px);
                }

                @media (min-width: ${breakpoints.values.lg}px) {
                    padding-top: calc(var(--next-header-lg-height, 6.5625rem) - 1px);
                }
            }

            #plp-search-banner-entrypoint{
                width: 100%;
                @media (max-width: ${breakpoints.values.lg - 1}px) {
                    padding-top: 0rem !important;
                }
            }
        `}
    />
)
